module.exports = __webpack_public_path__ + "static/media/TrendsIcon.6ef575ec.svg";